export default function Logo({ compact = false }) {
  // Official AMAA Design & Build logo. The artwork sits on a near-black field,
  // so mix-blend-screen lets the dark background melt into the site's dark
  // surfaces while the gold linework stays crisp — no box, no cropping.
  return (
    <a
      href="#home"
      data-testid="logo-link"
      className="flex items-center select-none"
      aria-label="AMAA Design & Build — home"
    >
      <img
        src="/images/logo.png"
        alt="AMAA Design & Build logo"
        width="512"
        height="512"
        className={`mix-blend-screen w-auto ${compact ? "h-14" : "h-24"}`}
        draggable="false"
      />
    </a>
  );
}
